import * as promotionsService from '@services/promotions-service';
import * as promotionType from './actionTypes';

export const setPromotions = (data) => ({
  type: promotionType.SET_PROMOTION,
  payload: data,
});

export const setIsLoadingPromotions = (data) => ({
  type: promotionType.SET_IS_LOADING_PROMOTIONS,
  payload: data,
});

export const setTokenForCreditLine = (data) => ({
  type: promotionType.SET_TOKEN_FOR_CREDIT_LINE,
  payload: data,
});

export const setTokenForCreditWithAccount = (data) => ({
  type: promotionType.SET_TOKEN_FOR_CREDIT_WITH_ACCOUNT,
  payload: data,
});

export const setTokenForInstallmentCredit = (data) => ({
  type: promotionType.SET_TOKEN_FOR_INSTALLMENT_CREDIT,
  payload: data,
});

export const setIsLoadingCreditLineToken = (data) => ({
  type: promotionType.SET_IS_LOADING_CREDIT_LINE_TOKEN,
  payload: data,
});

export const setIsLoadingCreditWithAccountToken = (data) => ({
  type: promotionType.SET_IS_LOADING_CREDIT_WITH_ACCOUNT_TOKEN,
  payload: data,
});

export const setIsLoadingInstallmentCreditToken = (data) => ({
  type: promotionType.SET_IS_LOADING_INSTALLMENT_CREDIT_TOKEN,
  payload: data,
});

export const fetchPromotions = () => (dispatch) => {
  dispatch(setIsLoadingPromotions(true));
  promotionsService.getPromotions().then((res) => {
    // eslint-disable-next-line no-sequences
    dispatch(setPromotions(res));
    dispatch(setIsLoadingPromotions(false));
  });
};

export const fetchTokenForCreditLineWidget = () => (dispatch) => {
  promotionsService.getTokenForCreditLine().then((res) => {
    // eslint-disable-next-line no-sequences
    dispatch(setTokenForCreditLine(res.token));
    dispatch(setIsLoadingCreditLineToken(false));
  });
};

export const fetchTokenForCreditWithAccountWidget = () => (dispatch) => {
  promotionsService.getTokenForCreditWithAccount().then((res) => {
    // eslint-disable-next-line no-sequences
    dispatch(setTokenForCreditWithAccount(res.token));
    dispatch(setIsLoadingCreditWithAccountToken(false));
  });
};

export const fetchTokenForInstallmentCreditWidget = () => (dispatch) => {
  promotionsService.getTokenForInstallmentCredit().then((res) => {
    // eslint-disable-next-line no-sequences
    dispatch(setTokenForInstallmentCredit(res.token));
    dispatch(setIsLoadingInstallmentCreditToken(false));
  });
};
